import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Utils } from 'src/app/common/services/utils.service';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { AppConfigService } from 'src/app/common/services/app-config.service';
import { MustMatch } from './must-match-pwd';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  changePassword: any;
  
  constructor(private authService: AuthService,
    private utils: Utils,
    private fb: FormBuilder,
    private httpService: HttpRequestService,
    private appConfigService: AppConfigService) { }

    onChangePassword(form) {
      form.methodName = 'changePassword';
      const requestData = {
        'workFlowName': 'CoreAdminService',
        'processType': 'Screen',
        'workFlowParams': JSON.stringify(form)
      };
  
      this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
        .subscribe((response) => {
          this.authService.setUserDetails(response['hdrcache'][0]);
        });
    }
  
    ngOnInit() {
      this.changePassword = this.fb.group({
        // strUserId: ['', Validators.required],
        strPassword: ['', Validators.required],
        strNewPassword: ['', Validators.required],
        strConfPassword: ['', Validators.required]
      }, {
          validator: MustMatch('strNewPassword', 'strConfPassword')
      });
    }

}
